/** @file What is left of a base entry's slot in its track's crossfade: the product over the links above it. */
import type { AnimState, TrackEntry } from '../../contracts/state';
import { mixWeight } from '../mixWeight';

/**
 * 1 while `owner` is base track `track`'s current entry; while the track crossfades out of it, the product of
 * (1 - mixWeight) of every link above it; 0 when `owner` is not in the track's from-chain (disposed, never played, or
 * an entry of another AnimState). A 0 means the owner has left or a link above fully covers it (a mix of 0), so its
 * fix layer goes (releaseFixLayer). Allocation-free.
 */
export function ownerCover(state: AnimState, track: number, owner: TrackEntry): number {
  let cover = 1;
  for (let e = state.tracks[track] ?? null; e !== null; e = e.from) {
    if (e === owner) return cover;
    cover *= 1 - mixWeight(e);
  }
  return 0;
}
